export default {
  data () {
    return {
      amount: null,
      words: '',
      num: {
        digit1: ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'],
        digit2: ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'],
        digit3: ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']
      }
    }
  },
  methods: {
    convertWords () {
      if (!this.amount) {
        this.words = ''
        return
      }

      const amt = this.amount.split('.')
      this.words = this.appendWords(amt[0]) + ' Rupees'
      if (amt[1]) {
        let decimal = amt[1].length === 1 ? amt[1] + '0' : amt[1]
        this.words += ' and ' + this.appendWords(decimal) + ' Paise'
      }
    },
    appendWords (amt) {
      let words = ''
      const len = amt.length

      for (let i = 0; i < len; i++) {
        const val = parseInt(amt.charAt(i))
        const revLen = len - 1 - i
        let increment = false
        words += ' '

        if ([1, 4, 6].includes(revLen) && val === 1) {
          words += this.num.digit2[parseInt(amt.charAt(i + 1))]
          increment = true
        } else if ([0, 2, 3, 5, 7].includes(revLen)) {
          words += this.num.digit1[val]
        } else {
          words += this.num.digit3[val]
        }

        if (val) {
          switch (revLen) {
            case 2: words += ' Hundred'
              break
            case 3: words += ' Thousand'
              break
            case 4: if (amt.charAt(i + 1) === '0' || val === 1) {
              words += ' Thousand'
            }
              break
            case 5: words += ' Lakhs'
              break
            case 6: if (amt.charAt(i + 1) === '0' || val === 1) {
              words += ' Lakhs'
            }
              break
            case 7: words += ' Crores'
              break
          }
        }

        if (increment) {
          i++
        }
      }
      return words.trim() || 'Zero'
    }
  }
}
